import { render, staticRenderFns } from "./DefectImageTab.vue?vue&type=template&id=07e21c58&scoped=true"
import script from "./DefectImageTab.vue?vue&type=script&lang=js"
export * from "./DefectImageTab.vue?vue&type=script&lang=js"
import style0 from "./DefectImageTab.vue?vue&type=style&index=0&id=07e21c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e21c58",
  null
  
)

export default component.exports